import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import CmtIssueStagePrepopulate from "./CmtIssueStagePrepopulate";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";

export default function CmtModal_OpenIssue(props) {
  const { modalState, toggleModal, selectedStageId } = props;

  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);

  const [openingRemarks, setOpenedRemarks] = useState("");
  const [starter, setStarter] = useState("none");
  const [selectedWorkflow, setWorkflow] = useState(null);
  const [selectedPresetStage, setPresetStage] = useState(null);
  const [initialStageTitle, setInitialStageTitle] = useState("Init. Assignment");
  const [selectedAssignTo, setAssignTo] = useState(null);

  const handleClick_open = async (e) => {
    e.preventDefault();
    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId: modalState.data.issueId,
      fieldsToUpdate: {
        openingRemarks,
        isOpen: true,
        openedByQmsUserId: modalState.data.qmsUserId,
        stagePrepopulationType: starter,
        appliedWorkflowId: selectedWorkflow ? selectedWorkflow.value : null,
        assignToQmsTeamId: selectedAssignTo ? selectedAssignTo.value : null,
        initialStageTitle,
      },
    });
    await dispatch(cmtIssueActions.open(modalState.data.issueId));
    if (selectedStageId && selectedStageId !== "initiated")
      dispatch(cmtIssueStageActions.get(modalState.data.issueId, selectedStageId));
    dispatch(cmtIssueActions.getAll(modalState.data.divisionId));
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"lg"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Open Issue
      </ModalHeader>
      <ModalBody>
        <div className="row mb-2">
          <div className="form-group col-12 mb-0">
            <label htmlFor="openingRemarks" className="mb-0 font-weight-bold">
              Remarks/Notes:
            </label>
            <textarea
              id="openingRemarks"
              name="openingRemarks"
              className="form-control"
              onChange={(e) => setOpenedRemarks(e.target.value)}
              rows={4}
            />
          </div>
        </div>
        <CmtIssueStagePrepopulate
          divisionId={modalState.data.divisionId}
          tabId={modalState.data.tabId}
          starter={starter}
          setStarter={setStarter}
          selectedWorkflow={selectedWorkflow}
          setWorkflow={setWorkflow}
          selectedPresetStage={selectedPresetStage}
          setPresetStage={setPresetStage}
          initialStageTitle={initialStageTitle}
          setInitialStageTitle={setInitialStageTitle}
          selectedAssignTo={selectedAssignTo}
          setAssignTo={setAssignTo}
        />
      </ModalBody>
      <ModalFooter>
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="open"
            id="open"
            className="btn btn-primary mr-2"
            onClick={handleClick_open}
          >
            {fetching && (
              <span className="mr-2 mt-1">
                <FontAwesomeIcon
                  icon="spinner"
                  className="loading-spinner"
                  style={{ color: "white" }}
                />
              </span>
            )}
            <b>Submit</b>
          </button>
          <button
            type="button"
            name="cancel"
            id="cancel"
            className="btn btn-secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
